import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ArrowUpRightBlue,
  facebookIcon,
  googleIcon,
  loginPageCover,
  loginVideo,
  logo,
  logoColor,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import { Input } from "../../stories/Input/Input";
import classes from "./LoginPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import CallMadeIcon from "@mui/icons-material/CallMade";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { useHistory } from "react-router-dom";
import { auth } from "../../firebase-config";
import errorMessage from "../../components/errorMessage";
import { toast } from "react-toastify";
import { saveLoginUserData } from "../../store/Actions/authAction";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import Colors from "../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import Fonts from "../../stories/assets/Fonts";

const LoginPage = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // variables and states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  // Login With Email and Password
  const handleSignInAction = async () => {
    try {
      setLoading(true);
      const response = await signInWithEmailAndPassword(auth, email, password);
      setLoading(false);

      let user = response.user;
      const customClaim = await user.getIdTokenResult();
      const role = customClaim?.claims?.role;
      const emailVerification = customClaim?.claims?.email_verified;
      if (role === "student") {
        await dispatch(saveLoginUserData(role));
        history.push({
          pathname: emailVerification ? `/homepage` : `/check-your-email`,
          state: email,
        });
      } else if (role === "coach-pending") {
        await dispatch(saveLoginUserData(role));
        history.push({
          pathname: emailVerification
            ? `/coach-setup-profile`
            : `/check-your-email`,
          state: email,
        });
      } else {
        toast.error(`No user found with this email sign up first.`);
      }
    } catch (error) {
      setLoading(false);
      const showErrorMessage = await errorMessage(error);
      toast.error(showErrorMessage);
    }
  };

  // Social Google Login
  const HandleGoogleLogin = async () => {
    let provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const emailVerification = customClaim?.claims?.email_verified;
        if (role === "student") {
          await dispatch(saveLoginUserData(role));
          history.push({
            pathname: emailVerification ? `/homepage` : `/check-your-email`,
            state: email,
          });
        } else if (role === "coach-pending") {
          await dispatch(saveLoginUserData(role));
          history.push({
            pathname: emailVerification
              ? `/coach-setup-profile`
              : `/check-your-email`,
            state: email,
          });
        } else {
          toast.error(`No user found with this email sign up first.`);
        }
      })
      .catch((error) => {
        toast.error(`Error While Google Login`);
      });
  };

  // Social Facebook Login
  const HandleFacebookLogin = async () => {
    let provider = new FacebookAuthProvider();
    provider.addScope("user_birthday");
    provider.setCustomParameters({
      display: "popup",
    });
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const emailVerification = customClaim?.claims?.email_verified;
        if (role === "student") {
          await dispatch(saveLoginUserData(role));
          history.push({
            state: email,
            pathname: emailVerification ? `/homepage` : `/check-your-email`,
          });
        } else if (role === "coach-pending") {
          await dispatch(saveLoginUserData(role));
          history.push({
            state: email,
            pathname: emailVerification
              ? `/coach-setup-profile`
              : `/check-your-email`,
          });
        } else {
          toast.error(`No user found with this email sign up first.`);
        }
      })
      .catch((error) => {
        toast.error(`Error While Facbook Login`);
      });
  };

  return (
    <>
      <style jsx>{`
        .${classes.mainHeading} {
          font-size: ${Fonts.h3.fontSize};
          line-height: ${Fonts.h3.lineHeight};
          font-family: ${`${Fonts.h3.fontFamily}`};
        }
      `}</style>
      <div className={` ${[classes.loginPage].join(" ")}`}>
        <div className={`container-fluid ${classes.container}`}>
          {isMobile ? (
            <MobileHeader
              isLogo={true}
              isAvatar={false}
              customStyle={{ padding: "0px" }}
            />
          ) : (
            <BeforeLoginHeader
              onClick={() => {
                history.push({
                  pathname: "welcome",
                });
              }}
              icon={logo}
              text1={"Don’t have an account?"}
              text2={"Get started"}
            />
          )}

          <div className="row" style={{ height: "100%" }}>
            <div className="col-md-12">
              <div className="row">
                <div
                  className={`p-0 col-md-6 ${[
                    classes.innerContainer,
                    classes.imageContainer,
                  ].join(" ")}`}
                >
                  {/* <img
                    className="img-fluid d-block w-100 hvh-100"
                    // className="img-fluid d-block w-100 hvh-100"
                    src={loginPageCover}
                  /> */}

                  <video
                    loop
                    autoPlay
                    muted
                    className={`${[classes.bannerVideo].join(" ")}`}
                  >
                    <source src={loginVideo} type="video/mp4" />
                  </video>
                  {/* <ReactPlayer url={welcomeVideo} loop={true} muted={true} playing={true} className={`${[classes.bannerVideo].join(" ")}`} /> */}
                </div>
                {/* Login Form */}
                <div
                  className={`p-5 col-sm-12 col-md-6  ${[
                    classes.innerContainer,
                    classes?.rightContainer,
                  ].join(" ")}`}
                >
                  <span className={` ${[classes.mainHeading].join(" ")}`}>
                    Welcome back
                  </span>
                  <form
                    className="col-md-12"
                    style={{
                      position: "relative",
                    }}
                  >
                    <div className={classes.inputMb32}>
                      <Input
                        type={"email"}
                        label={"Email"}
                        state={email}
                        setter={setEmail}
                      />
                    </div>
                    <span
                      className={`${[
                        classes.forgotSpan,
                        classes.mainColor,
                      ].join(" ")}`}
                      onClick={() => {
                        history.push({ pathname: "forgotPassword" });
                      }}
                    >
                      Forgot password{" "}
                      <CallMadeIcon
                        className={`${[classes.mainColor].join(" ")}`}
                        fontSize="small"
                      />
                    </span>
                    <Input
                      type={"password"}
                      label={"Password"}
                      state={password}
                      setter={setPassword}
                    />
                    <div className={classes.btnMt32}>
                      <Button
                        primary={true}
                        size={"Large"}
                        label={loading ? "loading..." : "Log in"}
                        disabled={
                          loading
                            ? true
                            : email !== "" && password !== ""
                            ? false
                            : true
                        }
                        onClick={() => {
                          if (email === "" || password === "") {
                            return toast.warning("Please fill all the fields");
                          }
                          handleSignInAction();
                        }}
                      />
                    </div>
                  </form>
                  <div className={`col-md-12`}>
                    <div
                      className={`${[classes.separatorContainer].join(" ")} `}
                    >
                      <div className={`${[classes.Separator].join(" ")}`} />
                      <div className={`${[classes.orSpan].join(" ")}`}>or</div>
                      <div className={`${[classes.Separator].join(" ")}`} />
                    </div>
                  </div>
                  <div className="mb-3 " />
                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Facebook"}
                    icon={facebookIcon}
                    onClick={() => {
                      HandleFacebookLogin();
                    }}
                  />
                  <div className="mb-3" />
                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Google"}
                    icon={googleIcon}
                    onClick={() => {
                      HandleGoogleLogin();
                    }}
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            {/* Dont have an account for mobile */}
            <div className={`col-sm-12 ${classes.footerContainer}`}>
              <div className={classes.dontHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Don’t have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Get Started"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/welcome")}
                />
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
